

import { RadioButton } from "primereact/radiobutton";
import PropTypes from "prop-types";

export  function PurchaseRadio(props) {
    return (
        <div className="card flex justify-content-center pl-1 pr-1">
            <div className="flex flex-wrap gap-3">
                {props.level.purchase()&&<div className="flex align-items-center">
                    <RadioButton inputId="selection1" name="Purchase" value="Purchase" onChange={(e) => props.setSelection(e.value)} checked={ props.selection==="Purchase"} disabled={!props.enableGlobalEdit} />
                    <label htmlFor="selection1" className="ml-2">Purchase</label>
                </div>}
                {props.level.afterSales()&& <div className="flex align-items-center">
                    <RadioButton inputId="selection2" name="Purchase" value="Warranty" onChange={(e) => props.setSelection(e.value)} checked={props.selection ==="Warranty"} disabled={!props.enableGlobalEdit}/>
                    <label htmlFor="selection2" className="ml-2">Warranty</label>
                </div>}
                {props.level.imports() &&<div className="flex align-items-center">
                    <RadioButton inputId="selection3" name="Purchase" value="Import" onChange={(e) => props.setSelection(e.value)} checked={props.selection ==="Import"} disabled={!props.enableGlobalEdit}/>
                    <label htmlFor="selection3" className="ml-2">Import</label>
                </div>}
            </div>
        </div>
    );
}
PurchaseRadio.propTypes = {
    selection: PropTypes.string.isRequired,
    setSelection: PropTypes.func.isRequired,
    enableGlobalEdit: PropTypes.bool.isRequired,
    level: PropTypes.object.isRequired,
}
